<template>
    <q-layout view="hHh lpR fFf">
        <!-- <q-header reveal elevated class="bg-white text-black">
            <q-toolbar elevated>
                <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center">
                    <div style="width: 200px"><q-btn unelevated round icon="chevron_left" @click="onBack" />설정</div>
                    <div style="width: 200px" align="right">
                        <q-btn unelevated round @click="onHome"> <q-icon unelevated round name="img:/assets/images/icon/icon_home.svg" size="20px" /></q-btn>
                    </div>
                </div>
 
            </q-toolbar>
        </q-header> -->
        <customHeader title="설정" path="settings" />
        <q-page-container>
            <q-page style="margin: 40px">
                <!-- <q-infinite-scroll @load="fetchData" :offset="250" class="caption"> -->
                <template v-for="(e, i) in infoList" :key="i">
                    <NoticeItem :isPrivate="isPrivate" :informData="e" :isDisableBtn="isDisableBtn" @on-open="onOpen" />
                </template>
                <!-- <template v-slot:loading> -->
                <!-- <div class="row justify-center q-my-md">
                            <q-spinner-dots color="primary" size="40px" />
                        </div>
                    </template>
                </q-infinite-scroll> -->

                <!-- <div v-else-if="noDataNotice" style="margin: 200px 0">
                    <NoData :message="`공지사항이 없어요!`" :btnTitle="`홈으로 가기`" />
                </div> -->
            </q-page>
        </q-page-container>
    </q-layout>

    <q-dialog persistent v-model="popPage">
        <q-card style="min-width: 600px; min-height: 600px">
            <q-card-section>
                <div class="flex align-center + justify-between">
                    <div class="text-h6">{{ isPrivate ? '개인정보 처리방침' : '이용약관' }}</div>
                    <q-icon name="close" align="right" size="20px" @click="popPage = false"
                        style="margin: 4px 4px 0 4px; float: right" />
                </div>
            </q-card-section>

            <q-separator />
            <p style="padding: 20px">{{ infoItem.contents }}</p>
        </q-card>
    </q-dialog>
</template>
<!-- {{agreementVersion: '0.2', contents: 'fffff', createdTs: '2023.02.22', s3ObjectName: 'dsafadsfdas'}

    "agreementVersion": "0.2",
    "contents": "fffff",
    "createdTs": "2023.02.22",
    "s3ObjectName": "dsafadsfdas"
  },{
    "contents": "약관내용",
    "createdTs": "2023.02.22",
    "creatorSeq": 0,
    "s3ObjectName": "aRefefe...",
    "termsVersion": "0.2"
  }, -->
<script setup>
import { onMounted, ref, computed } from 'vue';
import customHeader from '@/components/layouts/header/header.vue';

import NoticeItem from '@/views/myPage/components/noticeItem.vue';
import { getPrivateList, getTermsList } from '@/api/modules/mypage.js';

import { useQuasar } from 'quasar';
import { useRouter } from 'vue-router';
import { GlobalStore } from '@/store';
const gStore = GlobalStore();
const router = useRouter();
const $q = useQuasar();

const isDisableBtn = ref(false);
// const isDisableSubmitBtn = ref(true);

const isPrivate = ref(true);
const infoList = ref([]);
const infoItem = ref();
const noData = ref(false);
let noMoreData = false;
const popPage = ref(false);

const fetchData = async (index, done) => {
    if (isPrivate.value) getPrivate(index, done);
    else getTerms(index, done);
};

const getPrivate = async (index, done) => {
    // console.log('--getPrivate-- :');
    if (!noMoreData) {
        const res = await getPrivateList();
        const arrData = res.data.data;
        noMoreData = arrData.length === 0;
        // console.log('--first--res arrData:', arrData);
        infoList.value = [...infoList.value, ...arrData];
        // console.log('--first--infoList.value:', infoList.value);

        done();
        // console.log('--first--getPrivate:', infoList.value.length);
    }
    if (noMoreData) done(true);
};
const getTerms = async (index, done) => {
    if (!noMoreData) {
        const res = await getTermsList();
        const arrData = res.data.data;
        noMoreData = arrData.length === 0;
        infoList.value = [...infoList.value, ...arrData];
        done();
    }
    if (noMoreData) done(true);
};
const initData = async () => {
    if (isPrivate.value) {
        const res = await getPrivateList();
        const arrData = res.data.data;
        infoList.value = [...infoList.value, ...arrData];
        // console.log('--first--infoList.value:', infoList.value);
    } else {
        const res = await getTermsList();
        const arrData = res.data.data;
        noMoreData = arrData.length === 0;
        infoList.value = [...infoList.value, ...arrData];
    }
};
onMounted(() => {
    // : store에서 가져오기.
    isPrivate.value = gStore.is_private;
    initData();
});
////////////////////////////----OnClick----////////////////////////////
const onOpen = async (obj) => {
    // console.log('--agreeList - openPage--obj:', obj);
    isDisableBtn.value = true;
    infoItem.value = obj;
    setTimeout(() => {
        isDisableBtn.value = false;
    }, 1000);
    popPage.value = true;
};
const onBack = () => {
    router.push('/settings');
};
const onHome = () => {
    router.push('/learninghome');
};
</script>

<style lang="scss">
/*
.normal {
    width: 100px;
    border: 1px solid black;
    border-radius: 40px;
    background-color: white;
    color: #123;
}
*/
.hit {
    background-color: black;
    color: white;
}
</style>
